/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021 (original work) Open Assessment Technologies SA ;
 */
import { __ } from '@oat-sa-private/ui-core';

export default {
    select: {
        key: 'select',
        type: 'select',
        label: __('Select'),
        icon: 'select-16'
    },
    text: {
        key: 'text',
        type: 'text',
        label: __('Text'),
        icon: 'type-16'
    },
    brush: {
        key: 'brush',
        type: 'brush',
        label: __('Brush'),
        icon: 'brush-16',
        opener: true,
        onetime: true,
        tools: [
            {
                key: 'brush-small',
                label: __('Small brush'),
                icon: 'brush-8px-16',
                options: {
                    size: 8
                }
            },
            {
                key: 'brush-medium',
                label: __('Medium brush'),
                icon: 'brush-12px-16',
                options: {
                    size: 12
                }
            },
            {
                key: 'brush-large',
                label: __('Large brush'),
                icon: 'brush-16px-16',
                options: {
                    size: 16
                }
            }
        ]
    },
    rectangle: {
        key: 'rectangle',
        type: 'rectangle',
        label: __('Rectangle'),
        icon: 'rectangle-16',
        opener: true,
        tools: [
            { key: 'rectangle', type: 'rectangle', label: __('Rectangle'), icon: 'rectangle-16' },
            { key: 'oval', type: 'oval', label: __('Oval'), icon: 'oval-16' },
            { key: 'line', type: 'line', label: __('Line'), icon: 'line-16' }
        ]
    },
    eraser: {
        key: 'eraser',
        type: 'eraser',
        label: __('Eraser'),
        icon: 'eraser-16'
    }
};
